"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Input = _interopRequireDefault(require("../components/Input"));
var _excluded = ["isValid", "onFocus", "onBlur"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var withValidation = function withValidation(Component) {
  var WrappedComponent = function WrappedComponent(_ref) {
    var isValid = _ref.isValid,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
    var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];
    var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      dirty = _useState4[0],
      setDirty = _useState4[1];
    var handleFocus = function handleFocus(e) {
      if (!dirty) {
        setDirty(true);
      }
      setFocused(true);
      if (onFocus) {
        onFocus(e);
      }
    };
    var handleBlur = function handleBlur(e) {
      setFocused(false);
      if (onBlur) {
        onBlur(e);
      }
    };
    var showError = dirty && !focused && isValid === false;
    var variant = showError ? _Input["default"].VARIANTS.INVALID : isValid && _Input["default"].VARIANTS.VALID || undefined;
    return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, rest, variant ? {
      variant: variant
    } : {}, {
      onFocus: handleFocus,
      onBlur: handleBlur
    }));
  };
  WrappedComponent.propTypes = {
    isValid: _propTypes["default"].bool.isRequired,
    onFocus: _propTypes["default"].func,
    onBlur: _propTypes["default"].func
  };
  WrappedComponent.defaultProps = {
    onFocus: null,
    onBlur: null
  };
  return WrappedComponent;
};
var _default = exports["default"] = withValidation;